<script>

    import { onMount } from 'svelte';
    import { operationStore, query } from '@urql/svelte';
    import LoadingAnim from "./loadingAnim.svelte"
    import AirshowCard from "./airshowCard.svelte"

    //https://github.com/sveltejs/svelte/issues/3905#issuecomment-552928940$
    //handeling undefined fields
    const optional = x => x || '';

    const getArishows = operationStore(`
    {
      airshows: entries(section: "airshows") {
        title
        slug
        ... on airshows_default_Entry {
          teaser
          mainImage {
            url @transform (width: 1000, immediately: true)
          }
        }
      }
    }
    `);
    query(getArishows);

    onMount(() => {
        console.log('airshows Mounted')
    })
</script>
<main class="content">
    <h1>Airshows</h1>
    <section class="airshow-overview jetnoise-grid">
        {#if $getArishows.fetching}
            <LoadingAnim/>
        {:else if $getArishows.error}
            <p>Oh no... {$getArishows.error.message}</p>
        {:else}
            {#each $getArishows.data.airshows as airshow}
                <AirshowCard title="{airshow.title}" mainImageSrc="{optional(airshow.mainImage[0]).url}" teaser="{airshow.teaser}" slug="{airshow.slug}"/>
            {/each}
        {/if}
    </section>
</main>
<style>
    .airshow-overview {
        margin-top: var(--default-margin);
    }
</style>